import { gqlPromise, type DefaultContext } from '@egw/clients'
import { type HistoricalStockPricesInput, type HistoricalStockPricesOutput } from '../../models/chat/chat'

/**
 * Get Historical Stock Prices
 * @param historicalStockPricesInput - HistoricalStockPricesInput
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<HistoricalStockPricesOutput>
 * @example const stockPrices = await getHistoricalStockPrices(\{ ticker: 'AAPL', startDate: '2022-01-01', endDate: '2025-08-20' \});
 */
export const getHistoricalStockPrices = async (
  historicalStockPricesInput: HistoricalStockPricesInput,
  context?: DefaultContext,
): Promise<HistoricalStockPricesOutput> => {
  const response = (await gqlPromise(
    {
      name: 'historicalStockPrices',
      query: `
        query historicalStockPrices($historicalStockPricesInput: HistoricalStockPricesInput!) {
          historicalStockPrices(historicalStockPricesInput: $historicalStockPricesInput) {
            ... on HistoricalStockPrices {
              __typename
              ticker
              name
              exchange
              prices {
                date
                openPrice
                highPrice
                lowPrice
                closePrice
                volume
              }
            }
            ... on HistoricalStockPricesError {
              __typename
              errorType
            }
          }
        }`,
    },
    { historicalStockPricesInput },
    context,
  )) as { historicalStockPrices: HistoricalStockPricesOutput }
  return response.historicalStockPrices
}
